import './App.css';
import { Box } from '@chakra-ui/react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Appbar from './Components/Appbar/Appbar';
import Navbar from './Components/Navbar/Navbar';
import News from './Pages/News/News';
import Players from './Pages/Players/Players';
import RecentMatches from './Pages/RecentMatches/RecentMatches';
import LiveMatches from './Pages/LiveMatches/LiveMatches';
import Standings from './Pages/Standings/Standings';
import Statistics from './Pages/Statistics/Statistics';


function App() {
  return (
    <Box className="App" bg="#171717">
       <BrowserRouter>
        <Appbar/>
          <Routes>
            <Route index element={<News />} />
            <Route path="/players" element={<Players />} />
            <Route path="/recent/matches" element={<RecentMatches />} />
            <Route path="/match/stats/:id/:home/:away" element={<Statistics />} />
            <Route path="/live" element={<LiveMatches />} />
            <Route path="/standings" element={<Standings />} />
          </Routes>
        <Navbar/>
        </BrowserRouter>
    </Box>
  );
}

export default App;
